<template>
    <display-field :field="field" :no-help-text="noHelpText">
        <span v-if="values.length === 0">-</span>
        <span v-for="(value, index) in values" :key="index" class="form-value">
            <span v-if="choices">{{ value | choice(field) | capitalize }}</span>
            <span v-else>{{ value | capitalize }}</span>
            <span v-if="index !== values.length - 1">, </span>
        </span>
    </display-field>
</template>

<script>
    import DisplayField from "@/components/DisplayField";

    export default {
        name: "DisplayArrayField",
        components: {DisplayField},
        props: {
            field: {
                type: Object,
                required: true,
            },
            values: {
                type: Array,
                required: true,
            },
            choices: {
                type: Boolean,
                default: false,
            },
            noHelpText: {
                type: Boolean,
                default: false,
            }
        },
    };
</script>

<style scoped>

</style>